export function paletteSwatchLuminance(color) {
  if (!color || typeof color !== 'string') return 0.35;
  const s = color.trim().toLowerCase();
  if (s.startsWith('rgba')) {
    const m = s.match(/rgba\s*\(\s*([\d.]+)\s*,\s*([\d.]+)\s*,\s*([\d.]+)\s*,\s*([\d.]+)\s*\)/i);
    if (!m) return 0.35;
    const r0 = Number(m[1]);
    const g0 = Number(m[2]);
    const b0 = Number(m[3]);
    const a = Number(m[4]);
    if ([r0, g0, b0, a].some((n) => Number.isNaN(n))) return 0.35;
    const r = Math.round(r0 * a + 255 * (1 - a));
    const g = Math.round(g0 * a + 255 * (1 - a));
    const b = Math.round(b0 * a + 255 * (1 - a));
    return (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255;
  }
  if (s.startsWith('rgb(')) {
    const m = s.match(/rgb\s*\(\s*([\d.]+)\s*,\s*([\d.]+)\s*,\s*([\d.]+)\s*\)/i);
    if (!m) return 0.35;
    const r = Number(m[1]);
    const g = Number(m[2]);
    const b = Number(m[3]);
    if ([r, g, b].some((n) => Number.isNaN(n))) return 0.35;
    return (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255;
  }
  const hex = color.replace('#', '');
  if (hex.length !== 6) return 0.35;
  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);
  if (Number.isNaN(r) || Number.isNaN(g) || Number.isNaN(b)) return 0.35;
  return (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255;
}

export function paletteSwatchTextClass(color) {
  return paletteSwatchLuminance(color) > 0.72 ? 'ds-palette-swatch--light' : 'ds-palette-swatch--dark';
}
